import { Http } from "../Http";
import { RelatedServiceSetup } from "@apiModels/RelatedServiceSetup.csharp";

export interface IRelatedServiceApi {
  get(serviceId: string): Promise<RelatedServiceSetup[]>;
}

export class RelatedServiceApi implements IRelatedServiceApi {
  public get = (serviceId: string): Promise<RelatedServiceSetup[]> => {
    return Http.get(
        `/api/services/${serviceId}/related/setup`,
        null
    ) as Promise<RelatedServiceSetup[]>;
  };
}
